var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_PUBLIC = '/api/public';
const GET_PUBLIC_ORDERS_ROUTES = '/api/public/orders';
export const getOrderPublicReceipt = function (orderPublicToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_PUBLIC_ORDERS_ROUTES}/${orderPublicToken}/receipt`, config);
        }
        catch (error) {
            console.error('Error fetching getOrderPublicReceipt:', error);
            throw error;
        }
    });
};
export const getPosAppConfig = function (platform) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield this.axiosInstance.get(`${GET_PUBLIC}/app-config/pos`, {
                params: { platform }
            });
        }
        catch (error) {
            console.error('Error fetching getPosAppConfig:', error);
            throw error;
        }
    });
};
export const getHubAppConfig = function (platform) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield this.axiosInstance.get(`${GET_PUBLIC}/app-config/hub`, {
                params: { platform }
            });
        }
        catch (error) {
            console.error('Error fetching getHubAppConfig:', error);
            throw error;
        }
    });
};
